function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0313 7.54567L6.0625 11.4122L3.9375 9.34192L4.65625 8.64169L6.0625 10.0117L9.3125 6.84543L10.0313 7.54567ZM11.6563 2.30913C12.0313 2.30913 12.3438 2.44106 12.5938 2.70492C12.8646 2.94848 13 3.25293 13 3.61827V12.6909C13 13.0562 12.8646 13.3708 12.5938 13.6347C12.3438 13.8782 12.0313 14 11.6563 14H2.34375C1.96875 14 1.64583 13.8782 1.375 13.6347C1.125 13.3708 1 13.0562 1 12.6909V3.61827C1 3.25293 1.125 2.94848 1.375 2.70492C1.64583 2.44106 1.96875 2.30913 2.34375 2.30913H3V1H4.34375V2.30913H9.65625V1H11V2.30913H11.6563ZM11.6563 12.6909V5.56674H2.34375V12.6909H11.6563Z",
  fill: "#55586F"
});

function SvgReservations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservations);
export default __webpack_public_path__ + "static/media/reservations.d2de5950.svg";
export { ForwardRef as ReactComponent };